import { TableFilterConfig } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import { getTimeOffStatusOptions } from '@/modules/common/components/molecules/badge/status-configs/time-off-status-config';
import { TeamMemberStatusDTO } from '@/modules/common/types/team-member-status-dto';
import { getShortTeamMembers } from '@/modules/team/api/team.api';
import { renderTeamMemberFilterLabel } from '@/modules/team/helpers/team-member-dropdown-option';

import { getTimeOffTypesForFilter } from '../api/time-off-types.api';
import { TimeOffStatus } from '../types/time-off-status';
import { TimeOffTimeCategory } from '../types/time-off-time-category';
import {
  FILTER_KEY_REQUESTER_IDS,
  FILTER_KEY_STATUSES,
  FILTER_KEY_TIME_CATEGORY,
  FILTER_KEY_TYPES,
} from './time-offs-filter-keys';

const REQUESTER_FILTER_STATUSES = [
  TeamMemberStatusDTO.ACTIVE,
  TeamMemberStatusDTO.INVITED,
  TeamMemberStatusDTO.INVITE_EXPIRED,
  TeamMemberStatusDTO.BASIC,
  TeamMemberStatusDTO.ARCHIVED,
];

interface GetTimeOffsFiltersConfigParams {
  includeRequesterFilter?: boolean;
}

export const getTimeOffsFiltersConfig = ({
  includeRequesterFilter = false,
}: GetTimeOffsFiltersConfigParams = {}): TableFilterConfig[] => [
  {
    type: 'dynamic-autocomplete',
    name: FILTER_KEY_TYPES,
    label: i18n.t('authenticated.timeOff:filters.types'),
    withSearch: true,
    loadOptions: getTimeOffTypesForFilter,
    order: 1,
  },
  {
    type: 'autocomplete',
    name: FILTER_KEY_STATUSES,
    label: i18n.t('authenticated.timeOff:filters.status'),
    options: getTimeOffStatusOptions([
      TimeOffStatus.Pending,
      TimeOffStatus.Approved,
      TimeOffStatus.Declined,
      TimeOffStatus.Cancelled,
    ]),
    displayDot: true,
    withSearch: false,
    order: 2,
  },
  {
    type: 'autocomplete',
    name: FILTER_KEY_TIME_CATEGORY,
    label: i18n.t('authenticated.timeOff:filters.timeCategory'),
    options: [
      {
        value: TimeOffTimeCategory.Upcoming,
        label: i18n.t('authenticated.timeOff:timeCategory.upcoming'),
      },
      {
        value: TimeOffTimeCategory.Past,
        label: i18n.t('authenticated.timeOff:timeCategory.past'),
      },
    ],
    withSearch: false,
    order: 3,
  },
  ...(includeRequesterFilter
    ? [
        {
          type: 'dynamic-autocomplete' as const,
          name: FILTER_KEY_REQUESTER_IDS,
          label: i18n.t('authenticated.timeOff:filters.requester'),
          withSearch: true,
          loadOptions: async params =>
            getShortTeamMembers({
              filter: {
                searchString: params.searchString,
                statuses: REQUESTER_FILTER_STATUSES,
              },
              pagination: { cursor: params.cursor, pageSize: params.pageSize },
            }),
          renderLabel: (value, option) =>
            renderTeamMemberFilterLabel(value, {
              label: value,
              avatar: option.avatar,
              status: option.status,
            }),
          order: 4,
        },
      ]
    : []),
];
